(function () {
  "use strict";

  // Exibe/Oculta as categorias (Mobile)
  const $btnToggle = $(".toggle-categorias");
  const $categorias = $(".produtos-categorias");
  $btnToggle.on("click", function (ev) {
    ev.preventDefault();
    $btnToggle.text(
      $btnToggle.text() == "Categorias" ? "Ocultar" : "Categorias"
    );
    $categorias.slideToggle();
  });
})();
